import { render, staticRenderFns } from "./PurchaseOrder.vue?vue&type=template&id=d74c2bd8&"
import script from "./PurchaseOrder.vue?vue&type=script&lang=ts&"
export * from "./PurchaseOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports